var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChannelTypeCluster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 12a1.993 1.993 0 00-1.008.305L10.78 10.15a3.439 3.439 0 00.74-1.993L13.09 8a1.49 1.49 0 10-.089-.768l-1.591.128a3.512 3.512 0 00-1.978-2.521L9.74 4H10a2 2 0 10-1.01-.265l-.27.855a3.31 3.31 0 00-.754-.084c-.83 0-1.59.296-2.181.789L2.791 2.291a1.5 1.5 0 10-1.291.71c.281-.001.544-.079.767-.214L5.26 5.791a3.446 3.446 0 00-.76 2.168v.203l-.66.11a2 2 0 10.161.786L4 8.999l.63-.097a3.522 3.522 0 001.466 1.992l-.556 1.188a1.947 1.947 0 00-.539-.08h-.017a2 2 0 101.231.423l.566-1.153c.364.146.787.231 1.229.231.847 0 1.621-.311 2.216-.824l2.176 2.124a2 2 0 101.6-.8zm-9 3a1 1 0 110-2 1 1 0 010 2zm3-4.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelTypeCluster);
export default __webpack_public_path__ + "static/media/channelTypeCluster.e2be41c3.svg";
export { ForwardRef as ReactComponent };